import React from "react";
import "./App.css";
import Header from "./Components/Header";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Footer from "./Components/Footer";
import Home from "./Components/Home";
import Architecture from "./Components/Architecture";
import Construction from "./Components/Construction";
import InteriorDesign from "./Components/InteriorDesign";
import FitOut from "./Components/FitOut";

function App() {
  return (
    <>
      <Header />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/architecture" element={<Architecture />} />
          <Route path="/construction" element={<Construction />} />
          <Route path="/interiordesign" element={<InteriorDesign />} />
          <Route path="/fitout" element={<FitOut />} />
        </Routes>
      </BrowserRouter>
      <Footer />
    </>
  );
}

export default App;
